import React from "react";
import { getMatchModeLabel } from "../../lib/productCompartmentFillRules.js";
import { getFleetProductTone } from "../../utils/cropColors.js";
import { EXPANSION_PERCENT, expansionScene, mixingScene, sharingScene } from "../../utils/menuPlusHelpAnimations.js";
import TruckComparisonHelp from "./TruckComparisonHelp.jsx";

// Contenu des bulles animées du menu Plus. Chaque bulle compare l'option désactivée et activée sur le même camion.

const DATE_SCOPE = "Pour cette date, Jour et Soir. Une nouvelle date reprend la valeur de la date précédente.";

export function CompartmentSharingHelp() {
  const colors = { A: "#a13b67", B: "#3f5585" };
  return <TruckComparisonHelp dataKey="compartment-sharing" scene={sharingScene} colors={colors}
    lead={<>Une 2<sup>e</sup> commande du même produit termine un compartiment entamé.</>}
    rows={[
      { title: "Désactivé", key: "off", chip: "B ne tient pas · 2 chargements",
        notes: [{ key: "reserved", text: "2 t vides · réservées à A", top: "56%" }, { key: "refused", text: "B · 10 t ✕ 8 t libres", top: "46%", place: { between: [3, 4] } }] },
      { title: "Activé", key: "on", chip: "C2 : A + B · 1 seul chargement" },
    ]}
    legend={[{ color: colors.A, label: "A · 6 t" }, { color: colors.B, label: "B · 10 t" }, "même produit · 4 compartiments de 4 t"]}
    rules={["Même code et même type de produit.", "Proposé au déplacement, à la réactivation, au Chargé PM et au Preload.", "Optimiser laisse ces camions de côté.", DATE_SCOPE]} />;
}

export function ProductMixingHelp() {
  const colors = { A: getFleetProductTone("Trituro").accentColor, B: getFleetProductTone("T SOYA").accentColor };
  return <TruckComparisonHelp dataKey="product-mixing" scene={mixingScene} colors={colors}
    lead="Deux produits différents dans le même camion, chacun dans ses propres compartiments."
    rows={[
      { title: "Désactivé", key: "off", chip: "T SOYA refusé · autre chargement",
        notes: [{ key: "refused", text: "T SOYA refusé · produit différent", top: "46%", place: { between: [3, 4] } }] },
      { title: "Activé", key: "on", chip: "2 produits · compartiments distincts" },
    ]}
    legend={[{ color: colors.A, label: "Trituro · 8 t" }, { color: colors.B, label: "T SOYA · 8 t" }, "4 compartiments de 4 t"]}
    rules={["Jamais deux produits dans le même compartiment.", "Mélanges faits à la main (déplacement, réactivation).", "Optimiser laisse de côté les camions mélangés.", "Réglage partagé entre Jour et Soir."]} />;
}

export function ProductExpansionHelp({ rules = [] }) {
  const colors = { A: getFleetProductTone("Poulet").accentColor };
  return <TruckComparisonHelp dataKey="product-expansion" scene={expansionScene} colors={colors}
    lead="Limite le tonnage chargé dans chaque compartiment pour laisser de l’espace à l’expansion du produit."
    rows={[
      { title: "Désactivé", key: "off", chip: "12 t · compartiments pleins à 100 %",
        notes: [{ key: "full", text: "Plein à 100 % · aucune marge", top: "41%" }] },
      { title: "Activé", key: "on", chip: `12 t · ${EXPANSION_PERCENT} % = 3 t max par compartiment`,
        notes: [{ key: "margin", text: "1 t de marge pour l’expansion", top: "41%" }] },
    ]}
    legend={[{ color: colors.A, label: "Exemple : 12 t" }, `${EXPANSION_PERCENT} % de 4 t = 3,2 t, arrondi à 3 t`]}
    rules={[
      ...(rules.length
        ? rules.map((rule) => <><strong>{getMatchModeLabel(rule.match_mode)} {rule.pattern}</strong> : {rule.fill_percent} % max par compartiment</>)
        : ["Aucune règle : les compartiments se remplissent jusqu’à leur capacité."]),
      "Arrondi vers le bas à la demi-tonne. Plusieurs règles : le plus petit pourcentage.",
      "Désactivée : les règles restent, leurs plafonds sont ignorés. « Régler » modifie les règles.",
      "Pour cette date, Jour et Soir. Les tournées ne sont pas recalculées automatiquement.",
    ]} />;
}
